module.exports = "/fonts/FiraSans-Bold.ttf";